module.exports = __webpack_public_path__ + "img/step5.b13f268f.png";